import { consumer, ecommerce } from 'config/constants';
import { api } from 'config/index';
import SalesChannel from 'services/SalesChannel'
import VtexEvent from 'services/VtexEvent'

let attemptAtService = {
    search: 0,
    helpCenter: 0
};

let controllersRequest = {
    searchSuggestions: null,
    searchSuggestionsHelp: null
};

const _searchSuggestionsHelpCenter = (query, cancelReq = true, limit = false) => {
    if(!query) return Promise.resolve([]);

    if (cancelReq && controllersRequest.searchSuggestionsHelp) {
        controllersRequest.searchSuggestionsHelp.abort();
        controllersRequest.searchSuggestionsHelp = null;
    }

    let reqOptions = {
        headers: {
            'x-api-key': api.apiKey
        }
    };

    if (cancelReq && window && window.AbortController) {
        controllersRequest.searchSuggestionsHelp = new AbortController();
        reqOptions.signal = controllersRequest.searchSuggestionsHelp.signal;
    }

    return fetch(api.search + `/help-center/${query}${limit ? '?limit=10' : ''}`, reqOptions)
        .then(results => results.json())
        .then(results => _validationError('helpCenter', () => _searchSuggestionsHelpCenter(query), results))
        .then(results => {
            controllersRequest.searchSuggestionsHelp = null;
            if(results.status){
                results = [];
            }
            return results;
        })
        .catch(error => {
            controllersRequest.searchSuggestionsHelp = null;
            if(error.toString() === 'AbortError: The user aborted a request.') return false;
            return _validationError('helpCenter', () => _searchSuggestionsHelpCenter(query));
        });
}

const _searchSuggestions = (query) => {
    if(!query) return Promise.resolve([]);

    if (controllersRequest.searchSuggestions) {
        controllersRequest.searchSuggestions.abort();
        controllersRequest.searchSuggestions = null;
    }

    let reqOptions = {
        headers: {
            'x-api-key': api.apiKey
        }
    };

    
    const sc = SalesChannel.getSalesChannel();
    const seller = SalesChannel.getSeller();
    let url = api.searchV2 + `/search-suggestions/${query}?sc=${sc}`;

    if(ecommerce.whiteLabel) {
        reqOptions.headers['x-consumer'] = consumer;
        url = api.searchV2 + `/${seller}/search-suggestions/${query}?sc=${sc}`;
    }

    if (typeof window !== 'undefined' && window.AbortController) {
        controllersRequest.searchSuggestions = new AbortController();
        reqOptions.signal = controllersRequest.searchSuggestions.signal;
    }

    return fetch(url, reqOptions)
        .then(results => results.json())
        .then(results => _validationError('search', () => _searchSuggestions(query), results))
        .then(results => {
            controllersRequest.searchSuggestions = null;
            if(results.status){
                results = [];
            }
            return results;
        })
        .catch(error =>{
            controllersRequest.searchSuggestions = null;
            if(error.toString() === 'AbortError: The user aborted a request.') return false;
            return _validationError('search', () => _searchSuggestions(query));
        });
};

const _validationError = (name, callback, results = null) => {
    if(!(results && !(results.status && (results.message || results.statusMessage)))){
        return _attemptByError(name, callback);
    }

    attemptAtService[name] = 0;
    return results;
};

const _attemptByError = (name, callback) => {
    attemptAtService[name] = attemptAtService[name] + 1;

    if(attemptAtService[name] > 3){
        attemptAtService[name] = 0;
        return false;
    } else{
        return callback();
    }
}

let promiseCache = {
    promise: null,
    search: null
}


const getProducts = (search, page, body) => {

    let reqOptions = {
        headers: {
            'x-api-key': api.apiKey,
            'Content-Type': 'application/json'
        },
        method: 'POST',
        body: JSON.stringify(body)
    };
    const separator = search.indexOf('?') == -1 ? '?' : '&';
    let url  = api.catalog + `/search/${search}${page ? (separator+'page=') + page : '' }`;

    if( ecommerce.whiteLabel ){
        const sellerSelected = SalesChannel.getSeller();
        reqOptions.headers['x-consumer'] = consumer;
        reqOptions.headers['x-account'] = sellerSelected;
        url = api.catalog + `${sellerSelected ? '/'+sellerSelected : ''}/search/${search}${page ? '?page=' + page : '' }`
    }


    if(promiseCache.promise && (promiseCache.search === url + body && JSON.stringify(body.selectedFacets))){
        return promiseCache.promise;
    }

    promiseCache.search = url + body && JSON.stringify(body.selectedFacets);
    promiseCache.promise = fetch(url, reqOptions)
        .then(results => results.json())
        .then((results) => {
            promiseCache.promise = null;
            promiseCache.search = null;
            VtexEvent.query(search, results.recordsFiltered);
            return results;
        })

    return promiseCache.promise;
}

const getFacets = (search, params) => {
    let selectedFacets = [
        { "key": "trade-policy", "value": SalesChannel.getSalesChannel().toString() },
    ];

    if(params && params.category1){
        if(params.category3){
            selectedFacets.push({
                key: 'category-3',
                value: params.category3
            });
        } else if(params.category2){
            selectedFacets.push({
                key: 'category-2',
                value: params.category2
            });
        } else {
            selectedFacets.push({
                key: 'category-1',
                value: params.category1
            });
        }
    }

    let reqOptions = {
        headers: {
            'x-api-key': api.apiKey,
            'Content-Type': 'application/json'
        },
        method: 'POST',
        body: JSON.stringify({
            selectedFacets
        })
    };

    let url  = api.catalog + `/search/facets/${search}`;

    if( ecommerce.whiteLabel ){
        const sellerSelected = SalesChannel.getSeller();
        reqOptions.headers['x-consumer'] = consumer;
        reqOptions.headers['x-account'] = sellerSelected;
        url = api.catalog + `${sellerSelected ? '/'+sellerSelected : ''}/search/facets/${search}`
    }

    return fetch(url, reqOptions)
        .then(results => results.json())
}

const SearchService = {
    searchSuggesions: _searchSuggestions,
    searchSuggesionsHelp: _searchSuggestionsHelpCenter,
    getProducts,
    getFacets
};

export default SearchService;
